import type { Locale } from './types';

const durationUnits: Record<Locale, { hour: string; minute: string }> = {
  EN:{hour:'h',minute:'m'}, DE:{hour:'Std.',minute:'Min.'}, FR:{hour:'h',minute:'min'}, IT:{hour:'h',minute:'min'},
  ES:{hour:'h',minute:'min'}, RU:{hour:'ч',minute:'мин'}, PL:{hour:'godz.',minute:'min'}, PT:{hour:'h',minute:'min'},
};

export function formatDuration(seconds?: number | null, locale: Locale = 'EN'): string {
  if (!seconds || !Number.isFinite(seconds)) return '—';
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.round((seconds % 3600) / 60);
  const unit = durationUnits[locale];
  return hours ? `${hours} ${unit.hour} ${minutes} ${unit.minute}` : `${minutes} ${unit.minute}`;
}

export function formatClock(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  return hours
    ? `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    : `${minutes}:${String(secs).padStart(2, '0')}`;
}

export function formatBytes(bytes?: number): string {
  if (!bytes) return '—';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const power = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / 1024 ** power).toFixed(power > 2 ? 1 : 0)} ${units[power]}`;
}

